import { Vector3 } from "three";

export const yAxis = new Vector3(0, 1, 0);

export const isAndroid = () => {
    return /android/i.test(navigator.userAgent);
};

export const isIOS = () => {
    return (
        /iPad|iPhone|iPod/.test(navigator.userAgent) ||
        (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1)
    );
};

export const getMobileOS = () => {
    if (isAndroid()) {
        return "Android";
    } else if (isIOS()) {
        return "iOS";
    }
    return "Other";
};

export const awaitTimer = (timeMs: number) =>
    new Promise<void>(resolve => setTimeout(resolve, timeMs));

export const getDeviceLanguage = () => {
    return navigator.language.toLowerCase().substr(0, 2);
}